import { StationsList } from "../data/MenuData";
import formData from "../global/formDate";

export default function RaportTitleFromTo({station, dateFrom, dateTo}) {
    const name = StationsList.find(item => item.code === station);
    return station && name && 
        <h1 style={{fontSize: '24px', margin: '3vh 0'}}>Raport stacji 
            <span style={{textDecoration: 'underline'}}> {name.name}</span> od 
            <span style={{textDecoration: 'underline'}}> {formData(dateFrom)}</span> do 
            <span style={{textDecoration: 'underline'}}> {formData(dateTo)}</span>
        </h1>
};